import { ContentCount } from 'types'

export const DEFAULT_INSTAGRAM_CONTENTS: readonly ContentCount[] = [
  { type: 'story', count: 0 },
  { type: 'post', count: 0 },
  { type: 'reel', count: 0 },
] as const

export const DEFAULT_INSTAGRAM_REEL_CONTENT: ContentCount[] = [{ type: 'reel', count: 0 }] as const

export const DEFAULT_FACEBOOK_CONTENTS: readonly ContentCount[] = [
  { type: 'story', count: 0 },
  { type: 'post', count: 0 },
] as const

export const DEFAULT_TWITTER_CONTENTS: readonly ContentCount[] = [{ type: 'post', count: 0 }] as const

export const DEFAULT_LINKEDIN_CONTENTS: readonly ContentCount[] = [{ type: 'post', count: 0 }] as const

export const DEFAULT_TIKTOK_CONTENTS: readonly ContentCount[] = [{ type: 'post', count: 0 }] as const

export const DEFAULT_YOUTUBE_CONTENTS: readonly ContentCount[] = [{ type: 'short', count: 0 }] as const

export const DEFAULT_SEO_CONTENTS: readonly ContentCount[] = [{ type: 'blog_post', count: 0 }] as const

export const DEFAULT_EMAIL_CONTENTS: readonly ContentCount[] = [{ type: 'newsletter', count: 0 }] as const

export const DEFAULT_CROSSPOST_CONTENTS: readonly ContentCount[] = [{ type: 'post', count: 0 }] as const

export const DEFAULT_VIDEO_CROSSPOST_CONTENTS: readonly ContentCount[] = [{ type: 'post', count: 0 }] as const

export const DEFAULT_GOOGLE_BUSINESS_PROFILE_CONTENTS: readonly ContentCount[] = [{ type: 'post', count: 0 }] as const
